<template>
  <router-link
      to="/insurance-office-visit/table"
      v-if="$can('index', 'office_visit')"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-cardiogram"></i>
          <span class="menu-text">Office Visit</span>
        </a>
      </li>
    </router-link>
</template>

<script>
export default {
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
  },
};
</script>

<style></style>
